import React, { useState, useEffect } from 'react';

import { Routes, Route } from 'react-router-dom';

import UnauthorisedAccess from '../components/CommonComponents/UnauthorisedAccess';

import LoginForm from '../loginScreen';
import { PageNotFound } from '../components/shared/PageNotFound';

import MainScreen from '../MainScreen';
import Control from '../components/Control/Control';
import Warrantee from '../components/Warrantee/Warrantee';
import Customer from '../components/Customer/Customer';
import CustomerNewCustomer from '../components/Customer/CustomerNewCustomer';
import CustomerEditCustomer from '../components/Customer/CustomerEditCustomer';
import SerialNumberHistory from '../components/SerialNumber/SerialNumberHistory';
import SerialTicketHistoryView from '../components/SerialNumber/SerialTicketHistoryView';
import WarranteeEditCard from '../components/Warrantee/WarranteeEditCard';

import SerialNumber from '../components/SerialNumber/SerialNumber';
// -- TICKETS -- //
import Ticket from '../components/Ticket/Ticket';
//REPAIR TICKETS
import RepairTicketAddEdit from '../components/Ticket/RepairTickets/RepairTicketAddEdit';
import RepairTicketCheckAndAuth from '../components/Ticket/RepairTickets/RepairTicketCheckAndAuth';
//INSTALL TICKETS
import InstallTicketAddEdit from '../components/Ticket/InstallTickets/InstallTicketAddEdit';
import InstallTicketCheckAndAuth from '../components/Ticket/InstallTickets/InstallTicketCheckAndAuth';

// -- ARCHIVE -- //
import Archive from '../components/ArchivedTickets/Archive';
import RepairArchiveView from '../components/ArchivedTickets/RepairArchiveView';
import InstallArchiveView from '../components/ArchivedTickets/InstallArchiveView';

//TECH
import TechTimeAndAttendance from '../components/Tech/TechTimeAndAttendance';
import TechTicket from '../components/Tech/TechTicket';
//TECH REPAIR TICKETS
import TechRepairTicketView from '../components/Tech/TechRepairTickets/TechRepairTicketView';

import JobCard from '../components/JobCard/JobCard';

//TECH INSTALL TICKETS

import TechInstallTicketView from '../components/Tech/TechInstallTickets/TechInstallTicketView';

import InstallReport from '../components/InstallReport/InstallReport';

import InstallCheckList from '../components/InstallCheckList/InstallCheckList';

//ADMIN
import UsersAdmin from '../components/Administration/UsersAdmin';
import ConsumablesAdmin from '../components/Administration/ConsumablesAdmin';
import ConstantsAdmin from '../components/Administration/ConstantsAdmin';
import TimeAndAttendance from '../components/Administration/TimeAndAttendance';

//REPORTS
import InstallAnalysisReport from '../components/Reports/InstallAnalysisReport';
import PayrollReport from '../components/Reports/PayrollReport';
import SparesUsageReport from '../components/Reports/SparesUsageReport';
import BulkDataReport from '../components/Reports/BulkDataReport';
import TicketingReport from '../components/Reports/TicketingReport';

function NavRoutes() {
  const [useType, setUseType] = useState(localStorage.getItem('type'));

  useEffect(() => {
    const type = localStorage.getItem('type');
    console.log(`USER TYPE ${type}`);
    setUseType(type);
  }, []);
  return (
    <Routes>
      <Route path='/' element={<MainScreen />}>
        <Route index element={<Control />} />
        <Route path='notice' element={<Control />} />
        <Route path='warrantee' element={<Warrantee />} />
        <Route
          path='warrantee/warrantee_edit'
          element={
            <WarranteeEditCard
              rowData={{ test: 'dataTest' }}
              title={`Edit Customer`}
            />
          }
        />
        <Route path='ticket' element={<Ticket />} />
        <Route
          path='ticket/repair_ticket_edit'
          element={<RepairTicketAddEdit />}
        />
        <Route
          path='ticket/repair_ticket_auth'
          element={<RepairTicketCheckAndAuth />}
        />
        <Route
          path='ticket/install_ticket_edit'
          element={<InstallTicketAddEdit />}
        />
        <Route
          path='ticket/install_ticket_auth'
          element={<InstallTicketCheckAndAuth />}
        />
        <Route path='archive' element={<Archive />} />
        <Route
          path='archive/repair_archive_view'
          element={<RepairArchiveView />}
        />
        <Route
          path='archive/install_archive_view'
          element={<InstallArchiveView />}
        />

        <Route
          path='tech/timeandattendance'
          element={<TechTimeAndAttendance />}
        />
        <Route path='tech/tickets' element={<TechTicket />} />
        <Route
          path='tech/tech_install_ticket_view'
          element={<TechInstallTicketView />}
        />
        <Route
          path='tech/tech_repair_ticket_view'
          element={<TechRepairTicketView />}
        />

        <Route path='customer/customer_new' element={<CustomerNewCustomer />} />
        <Route path='customer' element={<Customer />} />
        <Route
          path='customer/customer_edit'
          element={<CustomerEditCustomer />}
        />
        <Route path='serial' element={<SerialNumber />} />
        <Route
          path='serial/serial_history'
          element={<SerialNumberHistory modalData />}
        />
        <Route
          path='serial/serial_history/ticket'
          element={<SerialTicketHistoryView />}
        />

        <Route path='tech/tech_ticket_view/jobcard' element={<JobCard />} />
        <Route
          path='tech/tech_ticket_view/installreport'
          element={<InstallReport />}
        />
        <Route
          path='tech/tech_ticket_view/checkSheet'
          element={<InstallCheckList />}
        />
        <Route path='admin/users' element={<UsersAdmin />} />
        <Route path='admin/consumables' element={<ConsumablesAdmin />} />
        <Route path='admin/constants' element={<ConstantsAdmin />} />
        <Route path='admin/time&attendance' element={<TimeAndAttendance />} />

        <Route
          path='reports/install_analysis'
          element={<InstallAnalysisReport />}
        />
        <Route path='reports/payroll' element={<PayrollReport />} />
        <Route path='reports/spares_usage' element={<SparesUsageReport />} />
        <Route path='reports/bulk_data' element={<BulkDataReport />} />
        <Route path='reports/ticketing' element={<TicketingReport />} />
      </Route>
      <Route path='*' element={<PageNotFound />} />
      <Route path='login' element={<LoginForm />} />
    </Routes>
  );
}

export default NavRoutes;
